<template>
    <div class="container">
        <div class="visual">
            <img class="wallpaper-visual d-md-none" :src="wallpaperMobileVisual" alt="">
            <img class="wallpaper-visual d-none d-md-block" :src="wallpaperDesktopVisual" alt="">
            <img class="device-visual" :src="deviceVisual" alt="">
        </div>
        <div class="bloc-text">
            <div class="inside-bloc-text text-center p-2">
                <p v-if="text" class="h3 mb-0" v-html="text" />
                <h2 class="h3 mb-0">
                    <span v-html="subtitle" />
                    <span v-if="recoveryDeviceModel && recoveryAmountInCents > 0" class="text-primary">
                        {{ recoveryDeviceModel }}
                        <span v-if="!manualEstimation"> {{ '&nbsp;?' }}</span>
                    </span>
                </h2>
                <template v-if="advantages">
                    <p class="py-0 mb-0">
                        <strong class="icon-rewards me-1 font-size-34" /><strong class="font-size-40" v-html="advantages" />
                    </p>
                    <p class="small mb-0 pt-0">
                        <small class="ps-3">{{ messages.recoveryText }}</small>
                        <small v-if="bonusAmountInCents > 0" class="ps-4">{{ messages.bonusText }}</small>
                    </p>
                </template>
                <div v-if="bonusRecoverySelectorLink && bonusRecoverySelectorLinkLabel" class="px-lg-4 px-xl-5">
                    <!--Cas où il faut afficher un lien vers le sélecteur de terminaux (bouton)-->
                    <ob1-boutons
                        class="mt-1"
                        :is-button="false"
                        :href="bonusRecoverySelectorLink"
                        :is-primary="true"
                        target="_blank"
                        :label="bonusRecoverySelectorLinkLabel"
                        data-oevent-label="vers_selecteur_avec_filtre_bonus"
                        data-oevent-category="ajout_bonus_reprise"
                        data-oevent-action="decouvrir_notre_selection"
                    />
                    <div>
                        <!--L'accès au simulateur est alors fait via un lien-->
                        <ob1-liens
                            class="mt-1 d-inline"
                            is-button
                            :with-arrow="true"
                            :modal-id="recoveryModalId"
                            :text="messages.ctaLabel"
                            data-bs-toggle="modal"
                            :data-bs-target="'#' + simulatorModalId"
                            data-oevent-label="vers_simulateur"
                            data-oevent-category="Banniere_reprise_mobile"
                            data-oevent-action="j_accede_au_simulateur"
                        />
                    </div>
                </div>
                <template v-else>
                    <!--Cas où il n'y a pas de lien vers le sélecteur de terminaux.
                        L'accès au simulateur est alors fait via un bouton-->
                    <ob1-boutons
                        class="mt-1 recovery-cta-button"
                        :is-primary="true"
                        :label="messages.ctaLabel"
                        data-bs-toggle="modal"
                        :data-bs-target="'#' + simulatorModalId"
                        data-oevent-label="vers_simulateur"
                        data-oevent-category="Banniere_reprise_mobile"
                        data-oevent-action="j_accede_au_simulateur"
                    />
                    <div v-if="recoveryModalId" class="text-center">
                        <!--Lien vers la popin de reprise-->
                        <ob1-liens
                            class="mt-1 d-inline"
                            is-button
                            :with-arrow="true"
                            :modal-id="recoveryModalId"
                            data-bs-toggle="modal"
                            :text="messages.linkLabel"
                            data-oevent-label="vers_popin_reprise"
                            data-oevent-category="Banniere_reprise_mobile"
                            data-oevent-action="tout_savoir_sur_la_reprise"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "OrangeMobileRecovery",
    props: {
        recoveryAmountInCents: {
            type: Number,
            default: null
        },
        recoveryDeviceModel: {
            type: String,
            default: null
        },
        manualEstimation: {
            type: Boolean,
            default: null
        },
        bonusAmountInCents: {
            type: Number,
            default: null
        },
        simulatorModalId: {
            type: String,
            required: true
        },
        recoveryModalId: {
            type: String,
            default: undefined
        },
        bonusRecoverySelectorLink: {
            type: String,
            default: null
        },
        bonusRecoverySelectorLinkLabel: {
            type: String,
            default: null
        },
        messages: {
            type: Object,
            required: true
        },
        deviceVisual: {
            type: String,
            required: true
        },
        wallpaperMobileVisual: {
            type: String,
            required: true
        },
        wallpaperDesktopVisual: {
            type: String,
            required: true
        }
    },
    computed: {
        subtitle() {
            if (!this.recoveryDeviceModel) {
                return this.messages.prospectSubtitle;
            } else if (this.recoveryAmountInCents > 0) {
                if (this.manualEstimation === true) {
                    return this.messages.estimatedSubtitle;
                } else {
                    return this.messages.identifiedSubtitle;
                }
            } else {
                return this.messages.recyclingSubtitle;
            }
        },
        text() {
            if (!this.recoveryDeviceModel || (this.manualEstimation === true && this.recoveryAmountInCents > 0)) {
                return undefined;
            } else if (this.recoveryAmountInCents > 0) {
                return this.messages.identifiedText + " " + this.formatAmount(this.recoveryAmountInCents);
            } else {
                return this.recoveryDeviceModel;
            }
        },
        advantages() {
            if (this.manualEstimation === true && this.recoveryAmountInCents > 0) {
                let advantages = this.formatAmount(this.recoveryAmountInCents);
                if (this.bonusAmountInCents > 0) {
                    advantages += " + " + this.formatAmount(this.bonusAmountInCents);
                }
                return "<span class=\"text-primary\">" + advantages + "</span>";
            } else {
                return undefined;
            }
        }
    },
    methods: {
        formatAmount: function (amountInCents) {
            if (amountInCents) {
                return PriceFormatter.formatEurosWithSpace(amountInCents / 100, false).toString();
            } else {
                return null;
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_variables';

.container {
    position: relative;
    padding: 0;
    overflow: hidden;
}

.visual {
    position: relative;
    width: 100%;
}

.wallpaper-visual {
    display: block;
    width: 100%;
    object-fit: cover;
}

.device-visual {
    position: absolute;
    bottom: 50%;
    left: 50%;
    width: min(58%, 15rem);
    transform: translateX(-50%) rotate(20deg);
    transform-origin: center center;
    z-index: 1;
    pointer-events: none;
}

.bloc-text {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 50%;
    z-index: 2;
}

.bloc-text.bg-gray2,
.bloc-text.bg-dark {
    background-color: transparent !important;
}

.inside-bloc-text {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: transparent;
}

@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .container {
        height: 300px;
    }

    .visual {
        height: 100%;
    }

    .wallpaper-visual {
        height: 100%;
    }

    .device-visual {
        top: 50%;
        bottom: auto;
        left: 25%;
        width: min(35%, 18rem);
        transform: translate(-50%, -50%) rotate(20deg);
    }

    .bloc-text {
        top: 0;
        bottom: auto;
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 1rem;
    }

    .inside-bloc-text {
        width: 100%;
        max-width: 32rem;
    }

    .recovery-cta-button {
        align-self: center;
    }
}

</style>
